var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnPlayerReport = function SvgIcnPlayerReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8329 14.6882V28.5007C31.8329 32.7507 29.297 34.1673 26.1662 34.1673H14.8329C11.702 34.1673 9.1662 32.7507 9.1662 28.5007V14.6882C9.1662 10.084 11.702 9.02148 14.8329 9.02148C14.8329 9.89982 15.187 10.6931 15.7678 11.274C16.3487 11.8548 17.142 12.209 18.0204 12.209H22.9787C24.7354 12.209 26.1662 10.7782 26.1662 9.02148C29.297 9.02148 31.8329 10.084 31.8329 14.6882Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1671 9.02148C26.1671 10.7782 24.7363 12.209 22.9796 12.209H18.0213C17.143 12.209 16.3496 11.8548 15.7688 11.274C15.1879 10.6931 14.8338 9.89982 14.8338 9.02148C14.8338 7.26482 16.2646 5.83398 18.0213 5.83398H22.9796C23.858 5.83398 24.6513 6.18816 25.2322 6.76899C25.813 7.34982 26.1671 8.14315 26.1671 9.02148Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8338 21.416H20.5005",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8338 27.084H26.1671",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnPlayerReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_player_report.310e3369.svg";
export { ForwardRef as ReactComponent };